module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/ig-images/ig-04-07bee4095cc47ba93af6ded456b004e7.jpg";